import { getErrorMessage } from "utils/error";

const DELETE_TEMPLATE_ERRORS: Record<string, string> = {
  cannot_delete_routing_target:
    "This variant is still used by an answer in template routing. Point that answer to another template, save, then delete the variant.",
  cannot_delete_default:
    "The default template can't be deleted. Make another template the default first.",
  cannot_delete_inactive: "This template has already been deleted."
};

export const getDeleteTemplateErrorMessage = (error: unknown) => {
  const message = getErrorMessage(error);
  return DELETE_TEMPLATE_ERRORS[message] ?? message;
};
